/* eslint-disable */

export const CommerceTerminalResultKind = {
  Succeeded: 'succeeded',
  ActionRequired: 'action_required',
  Processing: 'processing',
  QuoteChanged: 'quote_changed',
  Declined: 'declined',
  Blocked: 'blocked',
  RecoveryRequired: 'recovery_required'
} as const;
export type CommerceTerminalResultKind = typeof CommerceTerminalResultKind[keyof typeof CommerceTerminalResultKind];
